import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription, firstValueFrom } from 'rxjs';
import { StateVisitEnum } from 'src/app/enum/state-visit.enum';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { VisitModel } from 'src/app/models/preliminaries/visit.model';
import { VisitService } from 'src/app/services/preliminaries/visit.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-cancel-scheduled-visit',
  templateUrl: './cancel-scheduled-visit.component.html',
  styleUrls: ['./cancel-scheduled-visit.component.scss'],
  standalone: false
})
export class CancelScheduledVisitComponent implements OnInit {

  private readonly config = inject(DynamicDialogConfig);
  private readonly formBuilder = inject(FormBuilder);
  private readonly ref = inject(DynamicDialogRef);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly visitService = inject(VisitService);

  disable: boolean = false;
  formVisit: FormGroup = new FormGroup({});
  listConcept: any[] = [];
  suscription: Subscription;
  visitId: number = 0;
  visitModel: VisitModel = new VisitModel();

  async ngOnInit() {
    this.validateForm(new VisitModel());
    this.getListConcepts();
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.visitId = inputs.visitId;
      this.disable = inputs.disable;
    });
    if (this.disable) {
      setTimeout(() => this.formVisit.disable(), 100);
    }
    await this.getVisitById()
  }

  close(change: boolean) {
    const data: ModalObjectType = {};
    if (change) data.params = { reload: true };
    this.ref.close(data);
  }

  async getListConcepts() {
    try {
      this.listConcept = await firstValueFrom(this.visitService.getAllConcepsForSelectAsync());
    } catch (error) {
      console.error('Error al obetener la lista de conceptos.', error);
    }
  }

  async getVisitById() {
    try {
      this.visitModel = await firstValueFrom(this.visitService.getVisitById(this.visitId));
      this.validateForm(this.visitModel);
    } catch (error) {
      console.error('Error al buscar la visita programada.', error);
    }
  }

  async send() {
    Object.keys(this.formVisit.controls).forEach(key => {
      const control = this.formVisit.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formVisit.valid) {
      const modelVisit = this.formVisit.getRawValue() as VisitModel;
      if (modelVisit.observationCancel == '') modelVisit.observationCancel = null;
      this.visitModel.conceptId = modelVisit.conceptId;
      this.visitModel.observationCancel = modelVisit.observationCancel;
      this.visitModel.state = StateVisitEnum.Canceled;
      try {
        await firstValueFrom(this.visitService.changeState(this.visitModel));
        this.close(true);
        this.toastHandlerService.showToast('success', `La visita programada fue cancelada exitosamente.`, '');
      } catch (error) {
        console.error('Error al cancelar la visita programada.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      conceptId: {
        required: 'El campo Concepto Cancelación es obligatorio.',
        min: 'Debes seleccionar un Concepto Cancelación válido.'
      },
      observationCancel: {
        required: 'El campo Observación Cancelación es obligatorio.',
        maxlength: 'El campo Observación Cancelación permite máximo 250.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formVisit.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async validateForm(visit: VisitModel) {
    this.formVisit = this.formBuilder.group({
      conceptId: [visit.conceptId, [Validators.required, Validators.min(1)]],
      observationCancel: [visit.observationCancel, [Validators.maxLength(1000)]]
    });
  }

}
